import React, { useEffect, useState } from 'react';
import SearchBox from 'component/commonComponents/searchBox/search';
import { GlobalSearchContainer } from '../topNav.style';

export interface IGlobalSearchProps {
  initialKeywords?: string;
  startIcon?: string;
  onSearch?: (item: any) => void;
  pushToHistory?: (item: any) => void;
  placeholder?: string;
  hasAnimation?: boolean;
  isUnderKnowledgePage?: boolean;
  isNewJoiner?: boolean;
  isNewJoinerLoading?: boolean;
  isLastWorkingDay?: boolean;
  homeAccessibilityTranslation?: any;
};

const GlobalSearch: React.FC<IGlobalSearchProps> = ({
  initialKeywords,
  startIcon,
  onSearch,
  placeholder,
  hasAnimation,
  isUnderKnowledgePage,
  pushToHistory,
  isNewJoiner,
  isNewJoinerLoading,
  isLastWorkingDay,
  homeAccessibilityTranslation,
}) => {
  const [keywords, setKeywords] = useState(initialKeywords || '');

  useEffect(() => {
    if(!isUnderKnowledgePage) setKeywords('');
    else setKeywords(initialKeywords || '');
  }, [isUnderKnowledgePage, initialKeywords]);

  return (
    <>
      {(isNewJoinerLoading || isNewJoiner || isLastWorkingDay) ? <></> : <GlobalSearchContainer>
        <SearchBox
          keywords={keywords}
          onChange={setKeywords}
          onSearch={() => {
            if (onSearch && isUnderKnowledgePage) {
              onSearch(keywords);
            } else {
              pushToHistory?.(keywords);
            }
          }}
          placeholder={placeholder}
          hasAnimation={hasAnimation}
          startIcon={startIcon}
          searchIconLabel={homeAccessibilityTranslation?.searchIcon}
        />
      </GlobalSearchContainer>}
    </>
  );
};

export default GlobalSearch;
